import { CHINA_IN_PROVINCE, MAP_REGION_CN } from "@/utils/config";
import { EN_US } from "@/effects/switchLanguageEffect";

const normalizeProvinceKey = (name) =>
  String(name || "")
    .replace(/\s+/g, "")
    .toLowerCase();

const buildProvinceEnLookup = () => {
  const lookup = new Map();
  CHINA_IN_PROVINCE.forEach((item) => {
    if (item.textcn) {
      lookup.set(normalizeProvinceKey(item.textcn), item.text);
    }
    if (item.text) {
      lookup.set(normalizeProvinceKey(item.text), item.text);
    }
  });
  return lookup;
};

const PROVINCE_EN_LOOKUP = buildProvinceEnLookup();

/** 中文省份名 → 英文（CHINA_IN_PROVINCE.text） */
export const getChinaProvinceDisplayName = (provinceName, locale) => {
  if (!provinceName || locale !== EN_US) return provinceName;

  const direct = PROVINCE_EN_LOOKUP.get(normalizeProvinceKey(provinceName));
  if (direct) return direct;

  const keyNorm = normalizeProvinceKey(provinceName);
  const fuzzy = CHINA_IN_PROVINCE.find((item) => {
    const cnNorm = normalizeProvinceKey(item.textcn);
    return cnNorm && (keyNorm.includes(cnNorm) || cnNorm.includes(keyNorm));
  });
  return fuzzy?.text || provinceName;
};

/** 列表分组：英文模式下替换国内省份展示名 */
export const localizeGroupedDealersForDisplay = (groups, locale, mapRegion) => {
  if (locale !== EN_US || mapRegion !== MAP_REGION_CN) return groups || [];

  return (groups || []).map((country) => ({
    ...country,
    provinces: (country.provinces || []).map((province) => ({
      ...province,
      provinceName: getChinaProvinceDisplayName(province.provinceName, locale),
      dealers: (province.dealers || []).map((dealer) => ({
        ...dealer,
        provinceName: getChinaProvinceDisplayName(dealer.provinceName, locale),
      })),
    })),
  }));
};
